import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Stack,
} from '@mui/material';

interface CreateUserDialogProps {
  open: boolean;
  onCancel: () => void;
  onCreate: (username: string, email: string, password: string) => void;
  error?: string | null;
}

export const CreateUserDialog: React.FC<CreateUserDialogProps> = ({ open, onCancel, onCreate, error }) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  React.useEffect(() => {
    if (open) {
      setUsername('');
      setEmail('');
      setPassword('');
    }
  }, [open]);

  const valid = username.trim() && password.length >= 6;

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 'bold' }}>Create User</DialogTitle>
      <DialogContent>
        {error && (
          <DialogContentText color="error" sx={{ mb: 2 }}>{error}</DialogContentText>
        )}
        <Stack spacing={2} sx={{ pt: 1 }}>
          <TextField
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            size="small"
            fullWidth
            autoFocus
          />
          <TextField
            label="Email (optional)"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            size="small"
            fullWidth
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            size="small"
            fullWidth
            helperText="At least 6 characters"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!valid}
          onClick={() => onCreate(username.trim(), email.trim(), password)}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateUserDialog;
